import { render, staticRenderFns } from "./inventory-sold-list.vue?vue&type=template&id=dca8ed0e&"
import script from "./inventory-sold-list.vue?vue&type=script&lang=js&"
export * from "./inventory-sold-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports